import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import Layout from '../../../components/templates/Layout'
import CustomTable from '../../../components/molecules/CustomTable'
import CustomSearch from '../../../components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { handleRedirectInternal } from '../../../common/components'
import { useFormik } from 'formik'
import AlertContext from '../../../context/alert/alertContext'
import SettingContext from '../../../context/setting/settingContext'
import CustomDialog from '../../../../product/components/organisms/Dialog'
import PrimaryButton from '../../../components/atoms/PrimaryButton'
import ConfigManage from './ConfigManage'
import { useLocation } from 'react-router-dom'

const StaticPages = (props) => {
    const [isLoading, setIsLoading] = useState(true)
    const alertContext = useContext(AlertContext)
    const settingContext = useContext(SettingContext)
    const history = useHistory()
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')
    const { setAlert } = alertContext
    const {
        configurations,
        getAllConfigurations,
        configurationAction,
        updateDBSync,
        responseStatus: responseStatusCommuncation,
    } = settingContext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            enabled: 0,
            id: 0,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive'
            ) {
                dataValue.enabled = dataValue.action === 'active' ? 1 : 0
                delete dataValue.action
                configurationAction(values)
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (action === 'active' || action === 'deactive') {
            setChangeStatus(true)
        }
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: global.initialPageLimit || 20,
            order: '',
            orderby: '',
        },
        onSubmit: (values) => {
            isLoading(true)
            getAllConfigurations(values)
        },
    })

    useEffect(() => {
        if (configurations) {
            setTableBody(
                configurations.records.length ? configurations.records : []
            )
            setIsLoading(false)
        }
    }, [configurations])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllConfigurations(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from ===
                    'CommunicationStaticPages' &&
                responseStatusCommuncation.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllConfigurations(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    const tableValues = [
        {
            field: 'question',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Settings',
        },
        {
            field: 'value',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Value',
        },
        {
            field: 'enabled',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'enabled',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Deactive',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
        },
    ]

    const searchInfo = [
        {
            label: 'Page',
            placeholder: 'Enter Page',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    const tableActions = []
    tableActions.push(
        {
            label: 'Move to Active',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        },
        {
            label: 'Move to Deactive',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactive',
        }
    )

    return (
        <Layout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            {' '}
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="config_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Variable
                    </Button>
                    {edit ? (
                        <Button
                            id="db_sync"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() => updateDBSync()}
                        >
                            <span className="material-icons">backup</span>Update
                            DB Sync
                        </Button>
                    ) : null}
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={configurations}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllConfigurations}
                    columnStorageVariable={'table_config_setting_view'}
                />
            </div>
            <ConfigManage data={manage} function={toggleFullScreenPopup} />
            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'delete'
                        ? 'Are you sure you want to deactivate'
                        : 'Are you sure you want to enable'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="config_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="configView_cancel"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default StaticPages
